import React from 'react';
import { Pagination } from 'react-admin';

const OrderPagination = props => (
    <Pagination
        rowsPerPageOptions={[10, 20, 30, 40, 50, 100, 500]}
        {...props}
    />
);

export default OrderPagination;
